





















































































import { Vue, Component, Prop } from "vue-property-decorator";
import { IBrand } from "@/models/brands";
import _ from "@/boot/lodash";
import i18n from "@/i18n";

@Component({
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  }
})
export default class BrandGridItem extends Vue {
  // Props

  @Prop({ default: undefined })
  public brand?: IBrand;

  @Prop({ default: false })
  public canUpdate!: boolean;

  @Prop({ default: false })
  public canDelete!: boolean;

  @Prop({ default: false })
  public canWipeData!: boolean;

  @Prop({ default: false })
  public showWipeData!: boolean;

  @Prop({ default: false })
  public canViewOAuthClients!: boolean;

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: i18n.t("_action.manage_brand") })
  public actionLabel!: string;

  // Computed

  public get defaultOauthClient() {
    return _.find(this.brand?.oauth_clients || [], domain => domain.default)
      ?.origin;
  }

  // Methods

  public openDefaultOAuthClient() {
    const url = `${location.protocol}//${this.defaultOauthClient}${
      location.port ? `:${location.port}` : ""
    }`;
    window.open(url, "_blank");
  }
}
